"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Security = void 0;
const index_1 = require("../../v2/crypto/index");
const algoTypes_1 = require("../../v2/crypto/algoTypes");
class Security {
    static EncryptTypes;
    static AlgoTypes = algoTypes_1.AlgoTypes;
}
exports.Security = Security;
(function (Security) {
    Security.AllEncryptionTypes = {
        AES_CBC: index_1.AES_CBC,
        AES_GCM: index_1.AES_GCM,
        PBKDF2: index_1.PBKDF2,
        Standard: index_1.Standard,
    };
})(Security || (exports.Security = Security = {}));
//# sourceMappingURL=index.js.map